import React, { useCallback, useEffect, useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import UnityWebViewer from "../components/UnityWebViewer";
import {
  clearViewerSession,
  getViewerAccessToken,
  getViewerUserData,
} from "../services/authToken";


const ExperiencePage = () => {
  const { experienceId } = useParams();
  const navigate = useNavigate();
  const viewerAccessToken = getViewerAccessToken();
  const storedUserData = getViewerUserData();
  const handleExperienceAccessDenied = useCallback(() => {
    clearViewerSession();
    navigate("/join", { replace: true });
  }, [navigate]);

  useEffect(() => {
    if (viewerAccessToken && storedUserData) {
      return;
    }

    handleExperienceAccessDenied();
  }, [handleExperienceAccessDenied, storedUserData, viewerAccessToken]);

  const userData = useMemo(
    () =>
      viewerAccessToken && storedUserData
        ? {
            ...storedUserData,
            jwt: viewerAccessToken,
          }
        : null,
    [storedUserData, viewerAccessToken],
  );

  if (!viewerAccessToken || !storedUserData || !userData) {
    return null;
  }

  return (
    <div className="App">
      {/* <h2>Experience ID: {experienceId}</h2> */}
      <UnityWebViewer
        experienceId={experienceId}
        experienceRequestMode="viewer"
        onExperienceAccessDenied={handleExperienceAccessDenied}
        userData={userData}
      />
    </div>
  );
};

export default ExperiencePage;
